import { VIEW } from "@app/src/commons/sidebar/components/Sidebar/constants";
import React from "react";
import { Redirect, useLocation } from "react-router-dom";

export function RequireFlowMerchants({ children }) {

  const { pathname } = useLocation();
  const isFlowMultMerch = sessionStorage.getItem("isFlowMultMerch") === "1";
  const wentFlowMultMerch = sessionStorage.getItem("wentFlowMultMerch") === "1";
  const isServices = pathname === VIEW.SERVICES;

  if ((isServices && isFlowMultMerch && wentFlowMultMerch) || (isServices && !isFlowMultMerch)) {
    return <Redirect to={VIEW.CIP_GENERATION} />;
  }

  if (!isServices && isFlowMultMerch && !wentFlowMultMerch) {
    return <Redirect to={VIEW.SERVICES} />;
  }


  return children;
}